import PropTypes from "prop-types";
import { useState } from "react";

import CardShell from "./card_shell";
import { PasswordField } from "./fields";
import OAuthButtons from "./oauth_buttons";
import { ErrorSummary } from "./status_messages";

const InvitationPage = ({
  paths,
  authenticityToken,
  teamName,
  errors,
  googleTooltip,
  microsoftTooltip,
  passwordTooltipTitle = "Create a password",
  passwordTooltipBody = "Set a password to sign in with email and password — you can also share these credentials with a teammate. To send 1-on-1 emails or calendar invites from the contact profile, you'll need to also connect Google or Microsoft later.",
  submitLabel = "Create Account",
}) => {
  const [password, setPassword] = useState("");

  return (
    <CardShell>
      <h1 className="auth-subtitle text-center">Join {teamName}</h1>

      <OAuthButtons
        authenticityToken={authenticityToken}
        googlePath={paths.googleOauth}
        microsoftPath={paths.microsoftOauth}
        googleLabel="Sign in with Google"
        microsoftLabel="Sign in with Microsoft"
        googleTooltip={googleTooltip}
        microsoftTooltip={microsoftTooltip}
      />

      <div
        className="d-flex align-items-center text-muted small my-3"
        aria-hidden="true"
      >
        <span className="border-top flex-grow-1" />
        <span className="px-3">or</span>
        <span className="border-top flex-grow-1" />
      </div>

      <form action={paths.invitation} method="post">
        <input
          type="hidden"
          name="authenticity_token"
          value={authenticityToken}
        />
        <input type="hidden" name="_method" value="put" />

        <ErrorSummary errors={errors} />

        <PasswordField
          id="invitation_user_password"
          name="user[password]"
          label="Create a password"
          placeholder="Create a password"
          value={password}
          onChange={setPassword}
          autoComplete="new-password"
          tooltipTitle={passwordTooltipTitle}
          tooltipBody={passwordTooltipBody}
        />

        <button
          type="submit"
          className="btn btn-lg btn-block auth-primary-button"
        >
          {submitLabel}
        </button>
      </form>
    </CardShell>
  );
};

InvitationPage.propTypes = {
  paths: PropTypes.shape({
    invitation: PropTypes.string.isRequired,
    googleOauth: PropTypes.string.isRequired,
    microsoftOauth: PropTypes.string.isRequired,
  }).isRequired,
  authenticityToken: PropTypes.string.isRequired,
  teamName: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  googleTooltip: PropTypes.string.isRequired,
  microsoftTooltip: PropTypes.string.isRequired,
  passwordTooltipTitle: PropTypes.string,
  passwordTooltipBody: PropTypes.string,
  submitLabel: PropTypes.string,
};

export default InvitationPage;
